import styled from 'styled-components'
import {maxWidth} from 'core/theme'

export const Wrapper = styled.div`
  height: 50%;
  width: 100%;  
  .site-menu__header {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    height: 60px;
    padding-bottom: 20px;
    box-sizing: border-box;
    padding-left: 16px;
    padding-right: 32px;
  }
`

export const MenuItem = styled.div`
  .menu-item-symbol {
    margin-left: 10px;
    width: 13px;
    height: 13px;
    position: relative;
    .icon-arrow-right {
      position: absolute;
      top: calc(50% - 2px);
      left: 0;
      transform: rotate(90deg);
      width: 100%;
      height: 100%;
      &--selected {
        transform: rotate(-90deg);
      }
    }
  }
  .menu-item-dropdown-container {
    position: absolute;
    width: 288px;
    background-color: ${props => props.theme.colors.white};
    z-index: 1;
    box-sizing: border-box;
    .menu-item-dropdown {
      width: 100%;
      border-top: solid 1px ${props => props.theme.colors.gizmo};
      border-right: solid 1px ${props => props.theme.colors.gizmo};
      border-left: solid 1px ${props => props.theme.colors.gizmo};
      border-bottom: 5px solid ${props => props.theme.colors.smalt};
      box-sizing: border-box;
      box-shadow: 1px 1px 9px 0 rgba(0, 0, 0, 0.26);
      .menu-item-list {
        width: 100%;
        padding-left: 0px;
        list-style-type: none;
      }
    }
  }
  .selected-menu-item {
    border: 1px solid ${props => props.theme.colors.gizmo} !important;
    box-sizing: border-box;
    box-shadow: 1px 1px 9px 0 rgba(0, 0, 0, 0.26);
    z-index: 2;
    position: relative;
    top: 1px;
    &:after {
      content: ' ';
      position: absolute;
      width: 100%;
      height: 14px;
      bottom: -8px;
      left: 0px;
      right: 0px;
      z-index: 2;
      background-color: ${props => props.theme.colors.white};
    }
  }
  .menu-item-group-title {
    margin-left: 19px;
    font-family: ${props => props.theme.typography.lato};
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.19;
    letter-spacing: normal;
    color: ${props => props.theme.colors.pepper};
    padding-top: 15px;
  }
  &.normal {
    .menu-item-title-container {
      display: flex;
      text-align: center;
      padding: 6px 16px;
      border: 1px solid transparent;
      ${maxWidth.large`
        padding: 6px 8px;
      `};
      .menu-item-title {
        font-family: ${props => props.theme.typography.lato};
        font-size: 16px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: ${props => props.theme.colors.pepper};
        cursor: pointer;
        a {
          font-size: 16px;
          line-height: normal;
          color: ${props => props.theme.colors.pepper};
          cursor: pointer;
        }
      }
    }
    .menu-item-link {
      margin-top: 19px;
      margin-left: 19px;
      margin-bottom: 19px;
      a {
        color: ${props => props.theme.colors.pepper};
        vertical-align: middle;
        &:hover {
          color: ${props => props.theme.colors.royalBlue};
        }
      }
      svg.icon {
        margin-right: 8px;
        fill: ${props => props.theme.colors.mercuryBlue};
      }
      .icon-container {
        display: inline-table;
        vertical-align: middle;
        padding-right: 8px;
      }
      .title-container {
        display: inline-table;
        vertical-align: middle;
        height: 30px;
      }
    }
  }
  &.special {
    position: relative;
    flex-shrink: 0;
    flex-basis: 265px;
    cursor: pointer;
    .menu-item-title-container {
      text-align: center;
      padding: 6px 16px 6px 1px;
      margin-left: 15px;
      border: 1px solid ${props => props.theme.colors.gizmo};
      border-radius: 4px;
      top: 0px;
      .menu-item-title {
        width: 203px;
        height: 19px;
        font-family: ${props => props.theme.typography.lato};
        font-size: 16px;
        font-weight: normal;
        font-style: italic;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.5px;
        color: #fe5147;
      }
      svg {
        width: 13px;
        height: 13px;
        top: 5px;
      }
    }
    .menu-item-dropdown-container {
      position: absolute;
      z-index: 1;
      top: 35px;
      margin-left:15px;
      width: calc(100% - 15px);
      background-color: ${props => props.theme.colors.white};
      box-sizing: border-box;
      .menu-item-dropdown {
        width: 100%;
        border-top: solid 1px ${props => props.theme.colors.gizmo};
        border-right: solid 1px ${props => props.theme.colors.gizmo};
        border-left: solid 1px ${props => props.theme.colors.gizmo};
        border-bottom: 5px solid ${props => props.theme.colors.smalt};
        box-sizing: border-box;
        box-shadow: 1px 1px 9px 0 rgba(0, 0, 0, 0.26);
        .menu-item-list {
          width: 100%;
          padding-left: 0px;
          list-style-type: none;
        }
      }
    }
    .menu-item-link {
      padding: 9px 18px 9px 18px;
      &:hover {
        cursor: pointer;
        background-color: #e3eefc;
      }
      a {
        color: ${props => props.theme.colors.pepper};
        &:hover {
          color: ${props => props.theme.colors.royalBlue};
        }
      }
      svg.icon {
        margin-right: 8px;
      }
    }
  }
  
  @media screen and (min-width: 0px) and (max-width: 1024px) {
    .header-icon-container { display: none; }
    .header-menu { display: none; }
  }
  
  @media screen and (min-width: 1025px) {
    .slim-header-mp__mobile-utility { display: none; }
  }
`
